import { render, staticRenderFns } from "./MapsDataPrivacy.vue?vue&type=template&id=03bb4ecf"
import script from "./MapsDataPrivacy.vue?vue&type=script&lang=js"
export * from "./MapsDataPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports